import participant_contractor_roles from "dictionaries/participant_contractor_roles.json";
import createOptions from "utils/createOptions";

export default createOptions(participant_contractor_roles);
